// 部门(组织机构)实验交流
import request from '@/router/axios';


let urlPrefix = '/api/system/review';
/**
 * 根据id获取部门(组织机构)详情
 * @param {*} id 
 */
/**
 * 添加评论操作
 * @param {对象} row
 */
 export const addReview = params => {
    return request('/api/system/review/add', {
        method: 'post',
        data: params
    })
}

/**
 * 添加回复操作
 * @param {对象} row
 */
 export const addReviewReply = params => {
    return request('/api/system/review/add/reply', {
        method: 'post',
        data: params
    })
}


// 获取部门基本信息
export const getReviewList = deptId => {
    return request(`${urlPrefix}/select/${deptId}`)
}
